module.exports = __webpack_public_path__ + "media/front/ico-dropdown-a740816f.svg";